<template>
    <div v-if="isLinkVisible(row, query)" class="float-style">
        <a v-if="isExternal"
           :href="getUrl"
           target="_blank">
            <span v-if="title" v-popover:tooltip="t(title)" :style="{'background-color': getIconColor }" :class="externalIconClass"></span>
            <span v-else :style="{'background-color': getIconColor }" :class="externalIconClass"></span>
        </a>
        <a v-else
           href="#"
           @click.prevent="onClick"
        >
            <span v-if="title" v-popover:tooltip="t(title)" :style="{'background-color': getIconColor }" :class="internalIconClass"></span>
            <span :style="{'background-color': getIconColor }" :class="internalIconClass"></span>
        </a>
    </div>
</template>

<script>

import Vue from "vue";
import CustomModule from "../../pages/CustomModule/index";
import UrlResolver from "../../services/UrlResolver";
import ValueParser from "../../services/parser/ValueParser";
import ValueChecker from "../../services/ValueChecker";

let BootstrapComponent = Vue.extend(CustomModule);

export default {
    components: {},
    props: {
        config: {
            type: Object,
            default: function () {
                return {
                    iconColor: ''
                }
            }
        },
        state: {
            type: Object
        },
        eventBus: {
            type: Object,
        },
        iconClass: {
            type: String,
        },
        row: {
            type: Object,
        },
        query: {
            type: Object,
        },
        target: {
            type: String,
        },
        title: {
            type: String,
        },
        url: {
            type: String,
        },
    },
    data() {
        return {
            storage: null,
        };
    },
    computed: {
        getIconColor() {
            return this.config.iconColor;
        },
        getUrl() {
            return UrlResolver.resolveUrl(this.url, this.row, this.query, this.state);
        },
        externalIconClass() {
            if (ValueChecker.isUndefinedOrNull(this.iconClass)) {
                return 'icon icon-detail icon-new-tab';
            }

            return this.iconClass;
        },
        internalIconClass() {
            if (ValueChecker.isUndefinedOrNull(this.iconClass)) {
                return 'glyphicon glyphicon-chevron-down';
            }

            return this.iconClass;
        },
        isExternal() {
            return this.target === '_blank';
        }
    },
    beforeDestroy() {
        this.removeEmbeddedModule();
    },
    mounted() {
    },
    methods: {
        onClick: function () {
            let tr = $(this.$el).closest('tr');
            let table = $(tr.closest('table')).DataTable();
            let row = table.row(tr);
            let rowIndex = row.index();

            if (row.child.isShown()) {
                row.child.hide();

                this.removeEmbeddedModule();
            } else {
                row.child(() => {
                    return '<div class="loading-fragment"><div class="dataTables_processing panel panel-default">' + Vue.prototype.$translate.text('Processing') + '...</div></div>';
                }).show();

                let $el = $(row.child()[0]).find('div')[0];
                let route = UrlResolver.resolveRoute(this.url, this.row, this.query, this.state);

                let comp = new BootstrapComponent({propsData: {
                    rowIndex: rowIndex,
                }})

                Object.defineProperty(comp, '$route', {
                    value: route,
                    writable: false
                });

                Object.defineProperty(comp, '$root', {
                    value: this.eventBus,
                    writable: false
                });

                Object.defineProperty(comp, 'props', {
                    value: {rowIndex: rowIndex},
                    writable: false
                });

                this.storage = comp;

                comp.init(() => {
                    comp.$mount($el);
                });
            }
        },
        removeEmbeddedModule() {
            if (!ValueChecker.isUndefinedOrNull(this.storage)) {
                this.storage.$destroy();
                delete this.storage;
            }
        },
        isLinkVisible(row, query) {
            for (const [key, value] of Object.entries(query)) {
                if (!row.hasOwnProperty(value)) {
                    return false;
                }
            }
            return true
        }
    },
}
</script>

<style lang="sass">
    .float-style {
        float: right;
        margin-right: 3px;
        margin-left: 5px
    }
</style>


// WEBPACK FOOTER //
// EmbeddedModuleComponent.vue?22695698